<template>
  <popup
    :opened="dataToShow"
    @close="closePopup"
  >
    <div
      class="mx-5 xl:mx-44 2xl:mx-40 my-8 w-auto h-auto flex flex-col items-center space-y-10"
    >
      <h3>
        Choisir le compte à se connecter sur la structure {{ structure.name }}
      </h3>
      <div
        class="flex flex-col space-y-10 justify-center items-center w-full h-full"
      >
        <p
          v-if="accounts.length === 0"
          class="animate-pulse"
        >
          Chargement des utilisateurs de la structure {{ structure.name }}...
        </p>
        <div
          v-if="accounts.length > 0"
          class="flex flex-col space-y-10 items-center w-full"
        >
          <div class="w-full">
            <search-bar
              name="searchAccount"
              libelle=""
              :value="search"
              placeholder="Rechercher un compte"
              :big="false"
              :inherits="false"
              :has-border="false"
              @input="
                (newValue) => {
                  search = newValue;
                }
              "
            />
          </div>
          <div
            v-if="admins.length > 0"
            class="flex flex-col space-y-5 items-center w-full"
          >
            <p class="text-indigo-600">
              Administrateurs
            </p>
            <list-grid
              :list-items="admins"
              :is-listdisplayed="admins.length > 0"
              height-line="h-16"
              class="w-full"
            >
              <template #header>
                <div class="col-span-5 pl-5">
                  Nom
                </div>
                <div class="col-span-5">
                  Role
                </div>
                <div class="col-span-2">
                  Connexion
                </div>
              </template>
              <template #accordionDescription="{ item, num }">
                <div class="col-span-5 pl-5">
                  {{ item.firstname }} {{ item.lastname }}
                </div>
                <div class="col-span-5">
                  {{ item.role.name }}
                </div>
                <div class="col-span-2">
                  <circle-button
                    icon="monitor"
                    label="Accéder à l'interface Neopass de la structure"
                    @buttonClick="connectToAccount(item)"
                  />
                </div>
              </template>
            </list-grid>
          </div>

          <div
            v-if="referents.length > 0"
            class="flex flex-col space-y-5 items-center w-full"
          >
            <p class="text-indigo-600">
              Référents
            </p>
            <list-grid
              :list-items="referents"
              :is-listdisplayed="referents.length > 0"
              height-line="h-16"
              class="w-full"
            >
              <template #header>
                <div class="col-span-5 pl-5">
                  Nom
                </div>
                <div class="col-span-5">
                  Role
                </div>
                <div class="col-span-2">
                  Connexion
                </div>
              </template>
              <template #accordionDescription="{ item, num }">
                <div class="col-span-5 pl-5">
                  {{ item.firstname }} {{ item.lastname }}
                </div>
                <div class="col-span-5">
                  {{ item.role.name }}
                </div>
                <div class="col-span-2">
                  <circle-button
                    icon="monitor"
                    label="Accéder à l'interface Neopass de la structure"
                    @buttonClick="connectToAccount(item)"
                  />
                </div>
              </template>
            </list-grid>
          </div>

          <div
            v-if="beneficiaries.length > 0"
            class="flex flex-col space-y-5 items-center w-full"
          >
            <p class="text-indigo-600">
              Bénéficiaires
            </p>
            <list-grid
              :list-items="beneficiaries"
              :is-listdisplayed="beneficiaries.length > 0"
              height-line="h-16"
              class="w-full"
            >
              <template #header>
                <div class="col-span-5 pl-5">
                  Nom
                </div>
                <div class="col-span-5">
                  Role
                </div>
                <div class="col-span-2">
                  Connexion
                </div>
              </template>
              <template #accordionDescription="{ item, num }">
                <div class="col-span-5 pl-5">
                  {{ item.firstname }} {{ item.lastname }}
                </div>
                <div class="col-span-5">
                  {{ item.role.name }}
                </div>
                <div class="col-span-2">
                  <circle-button
                    icon="monitor"
                    label="Accéder à l'interface Neopass de la structure"
                    @buttonClick="connectToAccount(item)"
                  />
                </div>
              </template>
            </list-grid>
          </div>
        </div>
      </div>
    </div>
  </popup>
</template>

<script>
import { mapActions } from 'vuex';

import axios from '../../../api';
import ListGrid from '../../../components/AccordionTable/ListGrid.vue';
import CircleButton from '../../../components/CircleButton.vue';
import Popup from '../../../components/Popup.vue';
import Constants from '../../../constants';
import SearchBar from '../../../components/Inputs/SearchBar.vue';

export default {
  components: { Popup, ListGrid, CircleButton, SearchBar },
  name: 'ListAccountsToConnectPopup',

  props: {
    structure: Object,
    accounts: Array,
    dataToShow: Boolean,
  },

  data() {
    return {
      search: '',
    };
  },

  methods: {
    ...mapActions({
      changeStructure: 'auth/changeStructure',
    }),
    async connectToAccount(admin) {
      console.log('connexion...');
      await axios.get('/sanctum/csrf-cookie');
      await axios
        .get('/admin/connectToAccount/' + admin.id)
        .then(async (response) => {
          await this.changeStructure(this.structure.id);
          window.location.replace('/');
        })
        .catch((err) => {
          console.log(err);
        });
    },
    closePopup() {
      this.search = '';
      this.$emit('close');
    },
  },

  computed: {
    listFilter() {
      let filteredList = [];

      filteredList = [...this.accounts].filter(
        (account) =>
          account.firstname
            .toLocaleLowerCase()
            .includes(this.search.toLocaleLowerCase()) ||
          account.lastname
            .toLocaleLowerCase()
            .includes(this.search.toLocaleLowerCase()) ||
          (
            account.firstname.toLocaleLowerCase() +
            ' ' +
            account.lastname.toLocaleLowerCase()
          ).includes(this.search.toLocaleLowerCase()) ||
          (
            account.lastname.toLocaleLowerCase() +
            ' ' +
            account.firstname.toLocaleLowerCase()
          ).includes(this.search.toLocaleLowerCase())
      );
      return filteredList;
    },
    admins() {
      return this.listFilter.filter(
        (a) => a.role?.type === Constants.ROLE_TYPE_ADMIN
      );
    },
    referents() {
      return this.listFilter.filter(
        (a) => a.role?.type === Constants.ROLE_TYPE_MANAGER
      );
    },
    beneficiaries() {
      return this.listFilter.filter(
        (a) => a.role?.type === Constants.ROLE_TYPE_BENEFICIARY
      );
    },
  },
};
</script>
